import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { NotificationService,  LoaderService,  ErrorService, EVENTO, TOOLTIPS, ICONS, ACTIONS, UtilityService } from "../../../../shared/session/index";
import { Office, Ioffice } from "../shared/office.model";
import { OfficeService } from "../shared/office.service";
import { RegularExpressionMessage, RegularExpression, CustomValidators } from '../../../../shared/validation/customvalidation';
import { EmpresaService } from '../../empresa/shared/empresa.service';
import { Iempresa } from "../../empresa/shared/empresa.model";

@Component({
  selector: 'app-office-edit',
  templateUrl: 'office-edit.component.html'
})
export class OfficeEditComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;

  formGrupEditoffice: FormGroup;
  buttonGroup: any;
  office: Ioffice;
  officeName: string;
  nomofficeMaxLength: number;
  descriptionMaxLength: number;
  nomOfficePatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  msgErrorActualizar: string;
  msgErrorGet: string;
  obligatorioMsg: string;
  msgErrorGetOffices: string;
  offices: Office[];
  empresas: Iempresa;

  constructor(
    private loaderService: LoaderService,
    private officeService: OfficeService,
    private empresaService: EmpresaService,
    private notificationService: NotificationService,
    private errorService: ErrorService,
    public fb: FormBuilder) { }

  ngOnInit() {
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];

    this.msgErrorActualizar = 'Error al actualizar datos';
    this.msgErrorGet = 'Error al obtener datos';
    this.office = new Office(0, "", "", "", "", "", true, "", "", "", "", 0,"");
    this.setValuesFormBuilder();
    this.listarEmpresa();
    this.obtenerOffice(this.data.office.ID);

  }

  private setValuesFormBuilder() {
    this.formGrupEditoffice = this.fb.group({
      Name: [this.office.Name, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomofficeMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      Direccion: [this.office.Direccion, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomofficeMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      Referencia: [this.office.Referencia, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomofficeMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      Coordenadas: [this.office.Coordenadas,],
      Descripcion: [this.office.Descripcion, Validators.compose([
        Validators.maxLength(this.descriptionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      status: [this.office.Status]
    });
  }

  formGrupEditofficeSubmit(event) {
    if (this.formGrupEditoffice.invalid)
      return;
    this.office.Name = event.value.Name
    this.office.Direccion = event.value.Direccion;
    this.office.Referencia = event.value.Referencia;
    this.office.Coordenadas = event.value.Coordenadas;
    this.office.Descripcion = event.value.Descripcion;
    this.office.Status = event.value.status

    this.actualizarOffice(this.office);
  }

  changeEvent(office: Ioffice) {
    this.data.office = office;
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }


  private actualizarOffice(office: Ioffice) {
    this.loaderService.show();
    this.officeService.actualizarOffice(office)
      .subscribe(res => {
        this.changeEvent(office);
        
      },
        error => {
          this.notificationService.error(this.msgErrorActualizar);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  private obtenerOffice(officeID: number): void {
    this.loaderService.show();
    this.officeService.obtenerOffice(officeID)
      .subscribe(res => {
        this.office = res;
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.setValuesFormBuilder();
          this.loaderService.hide();
        });
  }
  private listarEmpresa(): void {
    this.loaderService.show();
    this.empresaService.listEmpresa()
      .subscribe(res => {
        this.empresas = res;
      },
        error => {
          this.notificationService.error("error al lsitar empresas");
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}
